/**
 * Accepts only non-empty SKU identifiers that are already normalized. Rejecting padded values
 * prevents the socket correlation key, selector state, and basket payload from diverging.
 */
const isValidSkuId = skuId => (
    typeof skuId === 'string'
    && skuId.length > 0
    && skuId === skuId.trim()
);

export default isValidSkuId;
